import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import yupSchema from "../../../../../constants/schema";
import { useErrorHandler } from "../../../../../hooks";
import DialogFormBuilder from "../../../../../components/dialog-form-builder";
import formQuestionService from "../../../../../services/form-question.service";
import { Grid } from "@material-ui/core";

const initialValues = {
    title: "",
    typeOfAnswer: "",
    selectOptions: []
};
const schema = Yup.object().shape({
    title: yupSchema.title128,
});

const defaultForm = [{
    _type: "textField",
    name: "title",
    label: "عنوان سوال",
    autoFocus: true,
},
{
    _type: "autocomplete",
    name: "typeOfAnswer",
    label: "نوع پاسخ",
    _type: "autocomplete",
    _wrapper: (props) => <Grid item xs={12} sm={4} {...props} />,
    options: [
        { value: "string", label: "پاسخ کوتاه" },
        { value: "text", label: "متن بلند" },
        { value: "number", label: "عدد" },
        { value: "select", label: "انتخابی" },
    ],
    valueSelector: "value",
    labelSelector: "label",
},]


export default function FormModalContent({ close, data, parent }) {
    const errorHandler = useErrorHandler();

    const [formQuestions, setFormQuestions] = useState(defaultForm)

    const handleSetNewItem = () => {
        setFormQuestions(prev => ([...prev, {
            _type: "array",
            _wrapper: (props) => <Grid item xs={12} {...props} />,
            _itemsWrapper: (props) => (
                <Grid item xs>
                    <Grid container spacing={2} {...props} />
                </Grid>
            ),
            name: "selectOptions",
            label: "پاسخ ها",
            dense: true,
            minLength: 1,
            emptyValue: {
                selectOption: "",
            },
            items: [
                {
                    _type: "textField",
                    _wrapper: (props) => <Grid item xs={12} sm={4} {...props} />,
                    name: "selectOption",
                    label: "پاسخ",
                }
            ],

        }]))
    }

    const handleSubmit = async (model, { setSubmitting }) => {
        const modelToSend = { ...model }
        modelToSend.selectOptions = JSON.stringify(modelToSend.selectOptions.map(item => item.selectOption))
        modelToSend.sectionId = parent.id;
        let op;
        if (data?.id) {
            op = await formQuestionService.edit(data.id, modelToSend);
        } else {
            op = await formQuestionService.create(modelToSend);
        }
        const { error } = op;
        setSubmitting(false);
        if (error) return errorHandler(error);

        close(true);
    };

    useEffect(() => {
        if (data) {
            if (data.typeOfAnswer === "select") {
                handleSetNewItem()
            } else {
                setFormQuestions([...defaultForm]);
            }
        }
    }, [])

    return (
        <DialogFormBuilder
            {...{
                close,
                name: "سوال",
                data,
                schema,
                initialValues: {
                    ...initialValues,
                    ...data
                },
                handleSubmit,
                handleChange: (key, value) => {
                    if (key === "typeOfAnswer") {
                        if (value.value === "select") {
                            handleSetNewItem()
                        } else {
                            setFormQuestions([...defaultForm]);
                        }
                    }
                },
                form: formQuestions,
            }}
        />
    );
}
